import { PrimaryNavIdentifier } from '@zola-helpers/client/dist/es/constants/navConstants';
import type { UserContext } from '@zola-helpers/client/dist/es/@types';
import getRegistry from './getRegistry';
import getAlbums from './getAlbums';
import getInvites from './getInvites';
import getWebsite from './getWebsite';
import getGuestList from './getGuestList';
import getWeddingBoutique from './getWeddingBoutique';
import getVendors from './getVendors';
import getAdvice from './getAdvice';

import { MegaMenuNavItem } from './types';
import { isInMarketplaceMegaMenuTest } from '../../../util/experimentFlags';

export const getPrimaryNavData = (
  userContext: UserContext | undefined
): { children: MegaMenuNavItem[] } => {
  return {
    children: [
      getRegistry(userContext),
      getInvites(),
      getWebsite(),
      getGuestList(),
      getWeddingBoutique(),
      getAlbums(),
      getVendors(),
      getAdvice(),
      // filter is a hack but it removes the null from getDashboard if user is not logged in
    ]
      .filter((node) => !!node)
      // position is 1-indexed here.,
      // The cast is because ts is not smart enough to know the null node is filtered out, so it thinks
      // there is a path where we end up with a { position: number} and nothing else in the result
      .map((node, i) => ({ ...node, position: i + 1 })),
  };
};

const getDataForComponent = (
  component: PrimaryNavIdentifier,
  userContext: UserContext | undefined
): MegaMenuNavItem | null => {
  switch (component) {
    case PrimaryNavIdentifier.REGISTRY:
      return getRegistry(userContext);
    case PrimaryNavIdentifier.PAPER:
      return getInvites();
    case PrimaryNavIdentifier.ALBUMS:
      return getAlbums();
    case PrimaryNavIdentifier.WEBSITE:
      return getWebsite();
    case PrimaryNavIdentifier.GUEST_LIST:
      return getGuestList();
    case PrimaryNavIdentifier.WEDDING_BOUTIQUE:
      return getWeddingBoutique();
    case PrimaryNavIdentifier.VENDORS: {
      return getVendors(isInMarketplaceMegaMenuTest(userContext || null));
    }
    case PrimaryNavIdentifier.ADVICE:
      return getAdvice();
    default:
      return null;
  }
};

export default getDataForComponent;
